import { loader } from 'graphql.macro'

const updateOnlineSchedulePricingMutation = loader('./updateOnlineSchedulePricing.graphql')

export default async function updateOnlineSchedulePricing ({ dataLoaders, variables }) {
  const response = await dataLoaders.dispatcher.graphQLClient.request(
    updateOnlineSchedulePricingMutation,
    { input: variables }
  )
  return response.updateOnlineSchedulePricing
}
